import { Filter } from './../types';

declare global {
  interface Array<T> {
    rigthJoin<T>(array: T[], key: string):  T[];
    firstOrNull<T>(): T;
    equals<T>(array: T[]): boolean;
    pipe<T>(func: (arr: T[]) => T[]): T[];
  }
}

Array.prototype.rigthJoin = function<T> (array: T[], key: string): T[] {
  return this.filter(it => array.findIndex(x => x[key] === it[key]) < 0); 
};

Array.prototype.firstOrNull = function<T> () : T {
  return this && this.length > 0 ? this[0] : null;
}

Array.prototype.equals = function<T> (array: T[]): boolean {
  if (!array)
    return false;
  if (this.length != array.length) 
    return false;
  for (var i = 0, l = this.length; i < l; i++) {
      if (this[i] instanceof Array && array[i] instanceof Array) {
          if (!this[i].equals(array[i]))
              return false;       
      }           
      else if (this[i] != array[i]) { 
          return false;   
      }           
  }       
  return true;
}

Array.prototype.pipe = function(func) {
  return func(this);
}
